import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 10px;
`

export const ActionButton = styled.button`
  background: none;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  cursor: pointer;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`

export const CustomLabel = styled.span`
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  margin-top: 4px;
  font-weight: 400;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const WhitelistDateRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 16px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: space-between;
`

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const SearchInputWrapper = styled.div`
  margin-right: 10px;
`

export const SearchSelect = styled.select`
  padding: 10px;
  margin-right: 5px;
  border-radius: 15px;
  border: 1px solid #dbdada;
  background: none;

  &:focus {
    outline: none;
  }
`

export const SearchInput = styled.input`
  padding: 10px;
  border-radius: 15px;
  border: 1px solid #dbdada;

  &:focus {
    outline: none;
  }
`

export const LogWrapper = styled.div`
  background-color: #dadada;
  padding: 10px;
  border-radius: 5px;
`
